import {ChangeDetectionStrategy, Component, EventEmitter, input, Output} from '@angular/core';
import {MatIcon} from '@angular/material/icon';
import {removeColor} from '@angular/cli/src/utilities/color';

@Component({
  selector: 'pas-fill-badge',
  standalone: true,
  imports: [
    MatIcon
  ],
  templateUrl: './fill-badge.component.html',
  styleUrl: './fill-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FillBadgeComponent {
  item = input<Unit>({} as Unit)
  @Output() removeItem = new EventEmitter<Unit>()

}
